import {
  readToolCallDisplay,
  TOOL_CALL_DISPLAY_METADATA_KEY,
} from '../../contracts/tool-call-display';

export const RPA_SKILL_WORKFLOW_METADATA_KEY = 'rpa_skill_workflow';

const TOOL_CALL_PROVIDER_METADATA_KEYS = [
  TOOL_CALL_DISPLAY_METADATA_KEY,
  RPA_SKILL_WORKFLOW_METADATA_KEY,
] as const;

/**
 * Copy only provider-metadata keys the Projects UI reads from live tool calls.
 * Stream envelopes can carry transport, approval, and child-run fields we do
 * not want persisted into client timeline state.
 */
export const readToolCallProviderMetadata = (
  metadata: Record<string, unknown>
): Record<string, unknown> | undefined => {
  const providerMetadata: Record<string, unknown> = {};

  for (const key of TOOL_CALL_PROVIDER_METADATA_KEYS) {
    if (key === TOOL_CALL_DISPLAY_METADATA_KEY) {
      const toolCallDisplay = readToolCallDisplay(metadata);
      if (toolCallDisplay) {
        providerMetadata[key] = {
          title: toolCallDisplay.title,
          ...(toolCallDisplay.detail ? { detail: toolCallDisplay.detail } : {}),
          ...(toolCallDisplay.planSteps ? { plan_steps: toolCallDisplay.planSteps } : {}),
        };
      }
      continue;
    }

    const value = metadata[key];
    if (value !== undefined) {
      providerMetadata[key] = value;
    }
  }

  return Object.keys(providerMetadata).length > 0 ? providerMetadata : undefined;
};
